// Co-Authored-By: AI-Assisted | updated: 2026-10-21 14:30:00
import { Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider, useLocation, useRouteError, Outlet } from "react-router-dom";
import { Skeleton, Result, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "@/component/layout";
import NotificationLayer from "@/component/notificationLayer";
import { apiLog } from "@/utils/api/common";
import { asyncAppReload } from "@/app/reducers/appReducer";
import { storage } from "@/utils/storage";
import routeConfig from "./base";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const uid = storage.get("user_id");
    apiLog({ path: location.pathname, path_info: "", params: location.search, source: 3, uid });
  }, [location.pathname, location.search]);
  return null;
}

function RootLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const appInitialized = useSelector((state) => state.app.initialized);

  useEffect(() => {
    if (!appInitialized && storage.get("token")) {
      dispatch(asyncAppReload(false));
    }
  }, [appInitialized, dispatch, location.pathname]);

  return (
    <Suspense fallback={<Skeleton active paragraph={{ rows: 6 }} title={false} style={{ minHeight: "calc(100vh - 160px)", padding: "20px", width: "100%" }} />}>
      <PageLayout>
        <NotificationLayer />
        <RouteTracker />
        <Outlet />
      </PageLayout>
    </Suspense>);
}

function RootErrorElement() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "未知错误，请重试";

  return (
    <div style={{ padding: "40px", textAlign: "center", minHeight: "calc(100vh - 160px)" }}>
      <Result
        status="error"
        title="页面加载失败"
        subTitle={message}
        extra={<Button type="primary" icon={<ReloadOutlined />} onClick={() => window.location.reload()} style={{ marginTop: 16 }}>刷新重试</Button>}
      />
    </div>
  );
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RootErrorElement />,
    children: routeConfig,
  },
]);

export default function Routes() {
  return <RouterProvider router={router} />;
}